import Interweave from "interweave"
import React from "react"

import { iArticleContentData } from "../../../types"
import { ContentSeparator } from "../../Utils/ContentSeparator"
import withTranslations from "../withTranslations"
import MetaData from "./MetaData"

export const ContentTitleView: React.FC<{ text: string }> = ({ text }) => (
  <div>
    <h1 className="text-3xl lg:text-4xl text-site-blue-dark">
      <Interweave content={text} />
    </h1>
  </div>
)

const ContentTitle: React.FC<{
  last_updated_at?: string
  read_time?: string
  onClickBookmark?: () => void
  onClickShare?: () => void
  content: iArticleContentData
  defaultLanguage: string | undefined
  bookmarked?: boolean | null
  onClickDiscussion: () => void
}> = ({
  content,
  defaultLanguage,
  last_updated_at,
  read_time,
  onClickBookmark,
  bookmarked,
  onClickShare,
  onClickDiscussion,
}) => {
  if (!content) return null
  const TitleWithTranslations = withTranslations(
    content.default,
    content.translations,
    defaultLanguage,
    ContentTitleView
  )
  return (
    <>
      <TitleWithTranslations />
      <MetaData
        last_updated_at={last_updated_at}
        read_time={read_time}
        onClickBookmark={onClickBookmark}
        bookmarked={bookmarked}
        onClickShare={onClickShare}
        onClickDiscussion={onClickDiscussion}
      />
      <ContentSeparator />
    </>
  )
}

export default ContentTitle
